import DateRangePicker from "@/components/DateRangePicker/dateRangePicker.component";
import TranslatedErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import FilterString from "@/components/FilterString/filterString.component";
import { Label } from "@/shadcn/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcn/components/ui/select";
import { QUOTE_STATUS, SimpleQuotation } from "@/types";
import React from "react";
import { DateRange } from "react-day-picker";

type FiltersQuoteTrackingProps = {
  status: "all" | SimpleQuotation["status"];
  setStatus: (status: "all" | SimpleQuotation["status"]) => void;
  createdAt: DateRange | undefined;
  setCreatedAt: (dateRange: DateRange | undefined) => void;
  company: string;
  setCompany: (company: string) => void;
  availableCompanies: string[];
};

const FiltersQuoteTracking: React.FC<FiltersQuoteTrackingProps> = ({
  status,
  setStatus,
  createdAt,
  setCreatedAt,
  company,
  setCompany,
  availableCompanies,
}) => {
  return (
    <TranslatedErrorBoundary
      fallback={<div className="text-red-600">Error loading filters</div>}
    >
      <div className="flex flex-wrap items-center gap-4">
        <div className="space-y-2">
          <Label>
            Status
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger className="w-32 capitalize">
                <SelectValue placeholder="Filter by Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem key={"all"} value={"all"}>
                  All
                </SelectItem>
                {Object.entries(QUOTE_STATUS).map(([key, value]) => (
                  <SelectItem key={key} value={value} className="capitalize">
                    {value}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </Label>
        </div>
        <div className="space-y-2">
          <Label>
            Created Date
            <DateRangePicker
              //   className="w-[300px]"
              date={createdAt}
              setDate={setCreatedAt}
            />
          </Label>
        </div>
        <div className="space-y-2">
          <FilterString
            filter={company}
            setFilter={setCompany}
            availableFilters={availableCompanies}
            label="Customer"
          />
        </div>
      </div>
    </TranslatedErrorBoundary>
  );
};

export default FiltersQuoteTracking;
